const AJS_ANONYMOUS_ID_KEY = 'ajs_anonymous_id';

const normalizeStoredAnonymousId = (value: string | null): string | undefined => {
  if (!value) {
    return undefined;
  }

  let decodedValue = value;
  try {
    decodedValue = decodeURIComponent(value);
  } catch {
    // Keep the original value if it is not URI encoded.
  }

  try {
    const parsedValue = JSON.parse(decodedValue);
    return typeof parsedValue === 'string' && parsedValue ? parsedValue : decodedValue;
  } catch {
    return decodedValue;
  }
};

const getLocalStorageAnonymousId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    return normalizeStoredAnonymousId(window.localStorage.getItem(AJS_ANONYMOUS_ID_KEY));
  } catch {
    return undefined;
  }
};

const getCookieAnonymousId = (): string | undefined => {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const cookiePrefix = `${AJS_ANONYMOUS_ID_KEY}=`;
  const cookie = document.cookie
    .split(';')
    .map(value => value.trim())
    .find(value => value.startsWith(cookiePrefix));

  return normalizeStoredAnonymousId(cookie?.slice(cookiePrefix.length) ?? null);
};

export const getPersistedLoomAnonymousId = (): string | undefined => {
  return getLocalStorageAnonymousId() ?? getCookieAnonymousId();
};
